export default "__VITE_ASSET__BiNIjXGb__"